import React from 'react';
import { string, arrayOf, func, bool } from 'prop-types';
import { Drawer, DrawerHeader, DrawerBody } from '@one-thd/sui-atomic-components';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { supplementalRecsdataModel } from '../dataModel';
import { SupplementalProductPodV7 } from './SupplementalProductPodV7';

const SupplementalRecsPods = ({
  productsData,
  schemaName,
  storeId,
  zipCode,
  handleViewDetailsClick,
  podTitle,
  isDrawerOpen,
  noATCFulfillment,
  parent
}) => {

  const defaultVariables = {
    storeId,
    zipCode,
    skipInstallServices: true,
  };
  const title = podTitle || 'Shop the Look';
  const analyticsParent = 'supplemental-recs';

  return (
    <>
      {
        productsData?.length
        && (
          <Drawer
            id={schemaName}
            open={isDrawerOpen}
            position="right"
            onClose={handleViewDetailsClick}
          >
            <DrawerHeader title={title} onClose={handleViewDetailsClick} />
            <DrawerBody name="recommendations-quick-view">
              <QueryProvider
                dataSource={schemaName}
                cacheKey={`${schemaName}-supplemental-recs-products`}
                defaultVariables={defaultVariables}
              >
                {
                  productsData.map((prod, idx) => {
                    return (
                      <SupplementalProductPodV7
                        key={idx}
                        itemId={prod?.product.itemId}
                        storeId={storeId}
                        position={idx}
                        parent={parent}
                        scheme={schemaName}
                        noATCFulfillment={noATCFulfillment}
                      />
                    );
                  })
                }
              </QueryProvider>
            </DrawerBody>
          </Drawer>
        )
      }
    </>
  );
};

SupplementalRecsPods.propTypes = {
  isDrawerOpen: bool,
  productsData: arrayOf(Object),
  storeId: string.isRequired,
  zipCode: string.isRequired,
  schemaName: string.isRequired,
  handleViewDetailsClick: func.isRequired,
  podTitle: string,
  noATCFulfillment: bool,
  parent: string
};

SupplementalRecsPods.defaultProps = {
  isDrawerOpen: false,
  productsData: null,
  podTitle: null,
  noATCFulfillment: true,
  parent: 'supplemental-recs'
};

SupplementalRecsPods.dataModel = supplementalRecsdataModel;
SupplementalRecsPods.displayName = 'SupplementalRecs';

export { SupplementalRecsPods };
